import React from 'react';
import Clients from './Clients';

function Prospects() {
  return <Clients category="prospect" />;
}

export default Prospects;
